import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import thunk from "redux-thunk";
import appReducer from "./reducers";

const composeEnhancers = composeWithDevTools({ trace: true });

export const appStore = createStore(
  appReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export type RootState = ReturnType<typeof appReducer>;
